import dayjs from "dayjs"
import { marketExportMessages } from "./marketExport.messages"

export type ExportTimeFrame = "currentMonth" | "customSelection" | "lastMonth"

export interface ExportTimeFrameFormValues {
	endDate: string
	startDate: string
	timeFrame: ExportTimeFrame
}

const DATE_FORMAT = "YYYY-MM-DD"

export const getExportTimeFrameDates = (timeFrame: Exclude<ExportTimeFrame, "customSelection">, today: Date) => {
	if (timeFrame === "currentMonth") {
		return {
			endDate: dayjs(today).format(DATE_FORMAT),
			startDate: dayjs(today).startOf("month").format(DATE_FORMAT),
		}
	}
	const lastMonth = dayjs(today).subtract(1, "month")
	return {
		endDate: lastMonth.endOf("month").format(DATE_FORMAT),
		startDate: lastMonth.startOf("month").format(DATE_FORMAT),
	}
}

// same calendar day in another year; like the market export API, a 29 February rolls over to 1 March
const addYears = (date: dayjs.Dayjs, years: number) => dayjs(new Date(date.year() + years, date.month(), date.date()))

export const getEarliestExportStartDate = (today: Date) => addYears(dayjs(today), -1).format(DATE_FORMAT)

export const validateExportTimeFrame = (startDate: string, endDate: string) => {
	const start = dayjs(startDate, DATE_FORMAT)
	const end = dayjs(endDate, DATE_FORMAT)

	if (start.isAfter(end)) {
		return marketExportMessages.startDateAfterEndDate
	}
	if (end.isAfter(addYears(start, 1))) {
		return marketExportMessages.timeFrameGreaterThan12Months
	}
	return undefined
}
